/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
saikrishna 11/25/2022  3031450488 Added BasicInfo new Ui fields
sai krishna 11/25 2022 3031450488 Added validation in BasicInfo
akhila 11/26/2022 3031450488 Added createdFor Dropdown
Saikrishna  11/29/2022  3031450488 Validations and requirement changes done in reports basic info.
Saikrishna 11/30/2022 3031450488  required changes dne for reports
Sai Maheshwar 12/01/2022 3031450488 changed validation message
Sai krishna 12/02/2022 2701350359 Fixed validation bug
akhila 12/03/2022 2701350359 changed Primary Accounts Only autocomplete to select
Sai Maheshwar 12/04/2022 3031450488 fixed UI issue
akhila 12/07/2022 3031450488 removed report code suggestion and add default value for createdFor
kavya9reddy 12/08/2022 3031450488 Added save button
Sai maheshwar 12/08/2022 3031450488 fixed unsaved changes alert bug
Raghu 12/09/2022 3031450488 Field Responsive alignment fixes
Sohel 12/13/2022 3031450488 conditionally hide Save Button
Suresh Peddavoora 12/16/2022 3031450488 Fixed save button alignments
Lalitha 12/23/2022 3031450488 Added reusable Validation in code
Ashraf 12/27/2022  3031450488  fixed seed only payload value
Sohel 02/09/2023 3031450488 fixed record code validation issue
Suresh Peddavoora 02/14/2022 3031450488 Fixed Multiselect label Alignment issue
Akhila 02/14/2023 3031450488 added codepopOver in report code field
Prakash 02/14/2023 3031450488 Implemented New UI Changes.
suresh peddavoora 02/28/2023 3031450488 New UI changes fixed
sohel 03/06/2023 3031450488 Added validation message for existing value
Raghu 03/09/2023 3031450488 New UI changes fixed
Prakash 03/17/2023 3031450488 fixed alignments in Responsive and desktop.
Ravi    04/13/2023 3031450488 Added use for Campaign field
Sohel 04/14/2023 3031450488 disabled Field Length.
Sohel 04/18/2023 3031450488 Campaign Field Changes
Akhila 04/19/2023 2700753823 modified clientCode dropDownData
Sohel 05/12/2023 2700753823 Fixed Reset Select Fields issue
sohel 06/11/2023 2700753823 fixed lowercase issue for report name existing code
*/
import {
  Button,
  FormHelperText,
  MenuItem,
  TextField,
  Select,
  InputLabel,
  FormControl,
} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useRef, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import PageLoader from '../../../../../components/PageLoader';
import {
  postHeaderInfo,
  resetMessage,
  fetchBasicInfo,
  getAllReportCodeData,
  getAllReportCreatedForData,
  resetReportFieldsData,
} from '../../../../../redux/reducers/ReportMaster';
import {currsorCodeIssue} from '../../../../../components/UpperCaseCode';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
import {createForOptions} from '../../../../../util/CreatedByForOptions';

const BasicInfo = ({activeStep, handleBack, handleNext, handleDirty, roleAccess}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    isLoading,
    successMsg,
    errorMsg,
    addHeaderStatus,
    reportMasterData,
    basicInfoData,
    reportCodeData,
    reportCode,
    reportCreatedForData,
  } = useSelector(({reportMaster}) => reportMaster);
  const [codePopover, setCodePopover] = useState(false);
  const [reportCodesData, setReportCodesData] = useState();

  const saveRef = useRef();
  const codeRef = useRef();
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const checkReportCodeExist = (value) => {
    if (reportCodeData && reportCodeData?.length > 0 && value) {
      const ar = [];
      reportCodeData?.forEach((i) => {
        if (
          i?.reportCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y' &&
          basicInfoData?.reportCode?.toLowerCase()?.trim() !== value?.toLowerCase()?.trim()
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkReportCodeAlreadyExist = (value) => {
    if (reportCodeData && reportCodeData?.length > 0 && value) {
      const ar = [];
      reportCodeData?.forEach((i) => {
        if (
          i?.reportCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N' &&
          basicInfoData?.reportCode?.toLowerCase()?.trim() !== value?.toLowerCase()?.trim()
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  const fixedLengthOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const dateStampOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const options = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const getObject = (option, options) => {
    let obj = {};
    options &&
      options?.map((ele) => {
        if (option === ele.value || option === ele.key || option === ele.userLoginName) {
          obj = ele;
        }
      });
    return obj;
  };
  const getReportCodesData = () => {
    if (reportCodeData && reportCodeData?.length > 0) {
      return reportCodeData?.filter((i) => String(i?.reportCode?.toLowerCase())?.startsWith(reportCodesData?.toLowerCase()));
    } else {
      return [];
    }
  };
  const validationSchema = Yup.object().shape({
    reportcode: Yup.string()
      .required('Report Name is required')
      .test('reportCode', 'Report Name already in use', (value) => !checkReportCodeExist(value))
      .test(
        'reportCode',
        'Report Name has already been used in the past',
        (value) => !checkReportCodeAlreadyExist(value),
      ),
    // title: basicInfoData?.reportTitle
    //   ? null
    //   : Yup.string()
    //       .required("Report name is required")
    //       .test("title", "Report name already exists", (value) => !checkReportTitleExist(value)),
    reportDescription: Yup.string()
      .required('Report Description is required'),
    fixedLength: Yup.object().nullable().required('Fixed Length is required'),
    dateStamp: Yup.object().nullable().required('Date Stamp Required is required'),
    seedOnly: Yup.string().required('Primary Accounts Only is required'),
    // recordsToInclude: Yup.object().nullable().required("Include Records is required"),
    campaign: Yup.string().required('Use For Campaign is required'),
  });
  const getClientCodes = (user, clientCodeData) => {
    return clientCodeData?.filter((i) => user?.includes(i?.clientNumber));
  };
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const initialState = {
    reportcode: basicInfoData?.reportCode ? basicInfoData?.reportCode : '',
    title: basicInfoData?.reportTitle ? basicInfoData?.reportTitle : '',
    fixedLength: basicInfoData?.fixedLength ?
      getObject(basicInfoData?.fixedLength, fixedLengthOptions) :
      {key: 'N', value: 'No'},
    dateStamp: basicInfoData?.requireDateStamping ?
      getObject(basicInfoData?.requireDateStamping, dateStampOptions) :
      {key: 'N', value: 'No'},
    campaign: basicInfoData?.campaignManager ? basicInfoData?.campaignManager : 'N',
    seedOnly: basicInfoData?.seedOnly ? basicInfoData?.seedOnly : 'N',
    // recordsToInclude: basicInfoData?.recordsToInclude
    //   ? getObject(basicInfoData?.recordsToInclude, includeRecordsOptions)
    //   : "",
    reportDescription: basicInfoData?.reportDescription ? basicInfoData?.reportDescription : '',
    createdFor: basicInfoData?.createdFor ?
      getObject(basicInfoData?.createdFor, reportCreatedForData) :
      {userLoginName: user?.userName},
    user:
      basicInfoData?.clientCode?.length > 0 ?
        getClientCodes(basicInfoData?.clientCode, clientCodeDropdownData) :
        [],
  };
  const handleSubmit = (values) => {
    const clientCode = values?.user?.length > 0 ? values?.user?.map((el) => el?.clientNumber) : [];
    if (values) {
      dispatch(submissionStart());
      const data = {
        createdFor: values?.createdFor?.userLoginName ? values?.createdFor?.userLoginName : '',
        fixedLength: values?.fixedLength?.key ? values?.fixedLength?.key : 'N',
        requireDateStamping: values?.dateStamp?.key ? values?.dateStamp?.key : 'N',
        // recordsToInclude: values?.recordsToInclude?.value ? values?.recordsToInclude?.value : "",
        reportCode: values?.reportcode ? values?.reportcode : '',
        reportDescription: values?.reportDescription ? values?.reportDescription : '',
        reportId: reportMasterData?.reportId ?
          reportMasterData?.reportId :
          basicInfoData?.reportId ?
            basicInfoData?.reportId :
            0,
        title: values?.title ? values?.title : '',
        seedOnly: values?.seedOnly ? values?.seedOnly : '',
        lastStep: saveRef.current ? 0 : 1,
        reportType: 'REPORT',
        clientCode: clientCode,
        campaignManager: values?.campaign ? values?.campaign : '',
      };
      dispatch(postHeaderInfo(data));
      // setReportCodeData(values?.reportcode);
    }
  };

  useEffect(() => {
    if (addHeaderStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        !saveRef.current && handleNext();
      }, 1000);
    }
  }, [addHeaderStatus]);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 500);
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    if (reportCode) {
      dispatch(fetchBasicInfo(reportCode));
    }
  }, [reportCode]);

  useEffect(() => {
    dispatch(getAllReportCodeData('REPORT'));
    dispatch(getAllReportCreatedForData());
    dispatch(resetReportFieldsData());
  }, []);

  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialState}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            dirty,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields mt-2">
                <div
                  className={`col-sm-6 col-md-4 ${
                    errors?.reportcode?.length > 30 ? 'form-group-lg' : 'form-group'
                  }`}
                >
                  <TextField
                    className={` ${classes.labelName}`}
                    placeholder="Enter Report Name"
                    margin="dense"
                    name="reportcode"
                    variant="outlined"
                    value={values?.reportcode}
                    label="Report Name"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    inputProps={{maxLength: 25}}
                    required
                    inputRef={codeRef}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      const value = currsorCodeIssue(codeRef);
                      setFieldValue('reportcode', value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setReportCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    touched={touched.reportcode}
                    error={Boolean(errors.reportcode && touched.reportcode)}
                    fullWidth
                  />
                  <FormHelperText style={{color: 'red'}} variant="outlined">
                    {touched.reportcode && errors.reportcode}
                  </FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getReportCodesData()?.map((data) => (
                        <MenuItem key={data?.reportCode}>{data?.reportCode?.replace(/ /g, '\u00a0')}</MenuItem>
                      ))}
                  </div>
                </div>
                {/* <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Report Name"
                    margin="dense"
                    name="title"
                    variant="outlined"
                    value={values.title}
                    disabled={Boolean(basicInfoData?.title)}
                    label="Report Name"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue("title", e.target.value);
                      if (e.target.value) {
                        setTitlePopover(true);
                        setReportTitleData(e.target.value);
                      } else if (e.target.value === "") {
                        setTitlePopover(false);
                      }
                    }}
                    touched={touched.title}
                    required
                    error={Boolean(errors.title && touched.title)}
                    fullWidth
                  />
                  <FormHelperText variant="outlined">
                    {touched.title && errors.title}
                  </FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {titlePopover &&
                      getReportTitleData()?.map((data, i) => (
                        <MenuItem key={i}>{data?.title}</MenuItem>
                      ))}
                  </div>
                </div> */}
                <div className="col-sm-6 col-md-4 col-xl-8 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    placeholder="Enter Report Description"
                    margin="dense"
                    name="reportDescription"
                    value={values.reportDescription}
                    variant="outlined"
                    label="Report Description"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    touched={touched.reportDescription}
                    inputProps={{maxLength: 100}}
                    required
                    error={Boolean(errors.reportDescription && touched.reportDescription)}
                    fullWidth
                  />
                  <FormHelperText variant="outlined">
                    {touched.reportDescription && errors.reportDescription}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="fixedLength"
                    id="fixedLength"
                    size="small"
                    options={fixedLengthOptions}
                    disabled={basicInfoData?.fixedLength}
                    required
                    value={values.fixedLength}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('fixedLength', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          required
                          // InputLabelProps={{ shrink: true }}
                          label="Fixed Length"
                          placeholder="Select Fixed Length"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText variant="outlined">
                    {touched.fixedLength && errors.fixedLength}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="createdFor"
                    id="createdFor"
                    size="small"
                    value={values.createdFor}
                    options={reportCreatedForData}
                    getOptionLabel={(option) => {
                      return option && option?.userLoginName ? option?.userLoginName : '';
                    }}
                    renderOption={(option) => {
                      return createForOptions(option);
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('createdFor', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          label="Report Owner"
                          // required
                          className={` ${classes.labelName}`}
                          placeholder="Select Report Owner"
                        />
                        <FormHelperText variant="outlined">
                          {touched.createdFor && errors.createdFor}
                        </FormHelperText>
                      </div>
                    )}
                  />
                </div>
                <div className={`form-group col-sm-2 col-md-4 col-xl-3 ${classes.selectField}`}>
                  <FormControl margin="dense" variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-label" required>
                      Primary Accounts Only
                    </InputLabel>
                    <Select
                      className={` ${classes.labelName}`}
                      label="Primary Accounts Only"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      fullWidth
                      name="seedOnly"
                      // className="select-gender"
                      value={values?.seedOnly ?? 'N'}
                      onChange={handleChange}
                      placeholder="Select seedOnly"
                      onBlur={handleBlur}
                      touched={touched?.seedOnly}
                      error={Boolean(touched?.seedOnly && errors?.seedOnly)}
                    >
                      {options.map((option) => {
                        return (
                          <MenuItem value={option.key} key={option.key}>
                            {option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormHelperText>
                    {touched?.seedOnly && errors.seedOnly && errors.seedOnly}
                  </FormHelperText>
                </div>
                {/* <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="campaign"
                    id="campaign"
                    size="small"
                    options={campaignOptions}
                    required
                    value={values.campaign}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue("campaign", value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          // className={` ${classes.labelName} ${classes.selectLabel}`}
                          variant="outlined"
                          margin="dense"
                          required
                          touched={touched.campaign}
                          error={touched.campaign && errors.campaign}
                          // InputLabelProps={{ shrink: true }}
                          label="Use For Campaign"
                          placeholder="Select Use For Campaign"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{ color: "red" }} variant="outlined">
                    {touched.campaign && errors.campaign}
                  </FormHelperText>
                </div> */}
                <div className={`form-group col-sm-2 col-md-4 col-xl-3 ${classes.selectField}`}>
                  <FormControl margin="dense" variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-label" required>
                      Use For Campaign
                    </InputLabel>
                    <Select
                      className={` ${classes.labelName}`}
                      label="Use For Campaign"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      fullWidth
                      name="campaign"
                      // className="select-gender"
                      value={values?.campaign ?? 'N'}
                      onChange={handleChange}
                      placeholder="Select Use For Campaign"
                      onBlur={handleBlur}
                      touched={touched?.campaign}
                      error={Boolean(touched?.campaign && errors?.campaign)}
                    >
                      {options.map((option) => {
                        return (
                          <MenuItem value={option.key} key={option.key}>
                            {option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormHelperText>
                    {touched?.campaign && errors.campaign && errors.campaign}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="dateStamp"
                    id="dateStamp"
                    size="small"
                    options={dateStampOptions}
                    disabled={basicInfoData?.requireDateStamping}
                    required
                    value={values.dateStamp}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('dateStamp', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          required
                          error={touched?.dateStamp && errors?.dateStamp}
                          touched={touched?.dateStamp}
                          onBlur={handleBlur}
                          // InputLabelProps={{ shrink: true }}
                          label="Date Stamp Required"
                          placeholder="Select Date Stamp Required"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText variant="outlined">
                    {touched.dateStamp && errors.dateStamp}
                  </FormHelperText>
                </div>
                {/* <div className="col-sm-6 col-md-4 col-xl-4 form-group">
                <FormControl margin="dense" variant="outlined" fullWidth>
                        <GuiAutoComplete
                          name={"user"}
                          id={"user"}
                          size="small"
                          limitTags={1}
                          classes={{
                            option: classes.option,
                            listbox: classes.listBox,
                          }}
                          disableCloseOnSelect
                          getOptionSelected={(option, value) =>

                            {option?.clientNumber === value?.clientNumber
                              console.log("option",option,option)}
                          }
                          value={values?.user?.length > 0 ? values?.user : []}
                          multiple
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue("user", value);
                          }}
                          options={clientCodeDropdownData || []}
                          autoHighlight
                          renderOption={(option, { selected }) => {
                            return (
                              <React.Fragment>
                                <>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={
                                      <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                    }
                                    checked={selected}
                                    className={classes.checkBox}
                                  />
                                </>
                                {option?.clientNumber} - {option?.clientName}
                              </React.Fragment>
                            );
                          }}
                          getOptionLabel={(option) => {
                            return option?.clientNumber + " - " + option?.clientName;
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                variant="standard"
                                margin="dense"
                                touched={touched}
                                error={touched?.user && errors?.user}
                                InputLabelProps={{ shrink: true }}
                                label={"Client Code"}
                                placeholder={`Select Client Code`}
                               // className={` ${classes.labelName} ${classes.selectLabel} ${classes.multiselectlabel} multiselect-label`}
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "off", // disable autocomplete and autofill
                                }}
                              />
                            </div>
                          )}
                        />
                      </FormControl>
                      <FormHelperText variant="outlined">
                        {touched?.user && errors?.user ? errors.user : ""}
                      </FormHelperText>
                      </div> */}
                {/* <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <Autocomplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="recordsToInclude"
                    id="recordsToInclude"
                    size="small"
                    options={includeRecordsOptions}
                    required
                    value={values.recordsToInclude}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue("recordsToInclude", value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <TextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          variant="outlined"
                          margin="dense"
                          InputLabelProps={{ shrink: true }}
                          label="Include Records"
                          placeholder="Select Include Records"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText variant="outlined">
                    {touched.recordsToInclude && errors.recordsToInclude}
                  </FormHelperText>
                </div> */}
              </div>
              <div className="new-standard-textfields d-flex justify-content-center align-items-center disabled-button">
                <Button
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Back
                </Button>
                {/* {isDraftReport === "N" && ( */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn mx-1 ${classes.buttonRoot}`}
                  disabled={roleAccess || enabledSubmission}
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  disabled={roleAccess || enabledSubmission}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default BasicInfo;
